import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api, DOMAIN_COLORS } from "@/lib/api";

export default function Domains() {
  const [domains, setDomains] = useState([]);
  useEffect(() => { api.get("/public/domains").then((r) => setDomains(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">Specialization Domains</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">9 domains. 45 constructs. One clear specialization fit.</h1>
        <p className="mt-5 text-base text-slate2 max-w-3xl">Each domain is composed of five constructs that capture a distinct facet of orientation. Together they explain not just <i>which</i> specialization fits — but <i>why</i> it fits.</p>
      </section>

      <section className="container-msis pb-24 space-y-12" data-testid="domains-list">
        {domains.map((d, i) => (
          <article key={d.code} className="grid lg:grid-cols-12 gap-8 border-t border-border pt-10">
            <div className="lg:col-span-4">
              <div className="flex items-center gap-3 mb-3">
                <span className="font-mono text-xs px-2 py-1 border" style={{ borderColor: DOMAIN_COLORS[d.code] + "55", color: DOMAIN_COLORS[d.code] }}>{d.code}</span>
                <span className="overline">Domain {String(d.no).padStart(2, "0")}</span>
              </div>
              <h2 className="font-display font-bold text-2xl tracking-tight" data-testid={`domain-${d.code}-name`}>{d.name}</h2>
              <p className="text-sm text-slate2 mt-3 leading-relaxed">{d.definition}</p>
              <p className="text-sm text-slate2 mt-3 italic leading-relaxed">{d.illustration}</p>
            </div>
            <div className="lg:col-span-8">
              <div className="overline mb-3">5 Constructs</div>
              <div className="grid sm:grid-cols-2 gap-px bg-border">
                {(d.constructs || []).map((c) => (
                  <div key={c.code} className="bg-white p-5">
                    <div className="flex items-start justify-between gap-3">
                      <div className="font-mono text-[11px] text-slate2">{c.code}</div>
                      <div className="font-mono text-[11px] text-slate2">{String(c.no).padStart(2, "0")}</div>
                    </div>
                    <div className="font-display font-semibold text-base mt-2">{c.name}</div>
                    <div className="text-xs text-slate2 mt-2 leading-relaxed">{c.definition}</div>
                  </div>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </Layout>
  );
}
